/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 积分
 */
import lodash from 'lodash';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import {
  BaseModel,
  BasesController,
  EnumBasesKeys,
  IBasesControllerOptions,
} from '../bases';
export class IntegralController<T = any> extends BasesController<T> {
  static options: {
    Integral: IBasesControllerOptions;
    SalesRank: IBasesControllerOptions;
    Task: IBasesControllerOptions;
    SalesTask: IBasesControllerOptions;
    RankISG: IBasesControllerOptions;
  } = {
    // 积分
    Integral: {
      dataKey: 'id',
      infinite: true,
      pagination: EnumAPI.integral_record_v2,
      details: EnumAPI.integral_account_v2,
      paginationParams: {
        currentKey: 'curPageNo',
        pageSizeKey: 'pageSize',
        filterKey: 'search',
        response: {
          dataSource: 'data',
          total: 'total',
        },
      },
    },
    // 排行
    SalesRank: {
      infinite: false,
      pagination: EnumAPI.integral_sales_rank,
      paginationParams: {
        currentKey: '',
        pageSizeKey: '',
        defaultCurrent: 0,
        defaultPageSize: 0,
        response: {
          valueGetter(res) {
            return {
              // 排行榜 获取除了数组第一个元素以外的全部元素。第一个是自己
              dataSource: lodash.tail(res),
              myself: lodash.head(res),
            };
          },
        },
      },
    },
    // 任务
    Task: {
      dataKey: 'id',
      infinite: true,
      pagination: EnumAPI.integral_task,
      paginationParams: {},
    },
    // Sales 任务
    SalesTask: {
      dataKey: 'id',
      infinite: true,
      pagination: EnumAPI.integral_task_sales,
      paginationParams: {
        currentKey: '',
        pageSizeKey: '',
        defaultCurrent: 0,
        defaultPageSize: 0,
        response: {
          valueGetter(res) {
            return {
              // 完成百分比
              current: lodash.get(res, 'complatePercent'),
              // 总积分
              total: lodash.get(res, 'totalAmount'),
              // 任务列表
              dataSource: lodash.get(res, 'taskDetail'),
            };
          },
        },
      },
    },
    // ISG排行
    RankISG: {
      infinite: false,
      pagination: EnumAPI.integral_sales_rank_quarter,
      paginationParams: {
        currentKey: '',
        pageSizeKey: '',
        defaultCurrent: 0,
        defaultPageSize: 0,
        response: {
          valueGetter(res) {
            return {
              // 排行榜 获取除了数组第一个元素以外的全部元素。第一个是自己
              dataSource: lodash.tail(res),
              // 自己
              myself: lodash.head(res),
            };
          },
        },
      },
    },
  };
  constructor() {
    super(IntegralController.options.Integral);
  }
  /**
   * 当前自己的排名
   * @readonly
   * @memberof IntegralController
   */
  @computed
  get myself() {
    return this.Pagination.Model.getStorage(`${EnumBasesKeys.response}.myself`);
  }
  /**
   * 切换积分为 Sales
   * @return {*}
   * @memberof IntegralController
   */
  onTriggerSales(isSales: boolean) {
    if (isSales) {
      this.reset(IntegralController.options.SalesRank);
      // 切换为  sales
      this.TaskController.reset(IntegralController.options.SalesTask);
    } else {
      this.reset(IntegralController.options.Integral);
      this.TaskController.reset(IntegralController.options.Task);
    }
  }
  /**
   * 切换积分为 ISG
   * @return {*}
   * @memberof IntegralController
   */
  onTriggerISG(code: string, isYear = false) {
    switch (code) {
      case 'ranking':
        if (isYear) {
          this.reset({
            ...IntegralController.options.RankISG,
            pagination: EnumAPI.integral_sales_rank_year,
          });
        } else {
          this.reset(IntegralController.options.RankISG);
        }
        break;
      case 'my':
        this.reset(IntegralController.options.Integral);
        break;
      case 'task':
        this.TaskController.reset(IntegralController.options.Task);
        break;
    }
  }
  /**
   * 积分明细 过期积分 切换
   * @return {*}
   * @memberof IntegralController
   */
  onTriggerOverdueIntegral(code) {
    if (code == '2') {
      this.reset({
        ...IntegralController.options.Integral,
        pagination: EnumAPI.integral_record_queryExpireIntegral,
      });
    }
    if (code == '0') {
      this.reset(IntegralController.options.Integral);
    }
  }
  /**
   * 完成新手任务
   * @param regEx
   * @returns
   */
  onNewTask(regEx: 'pdf' | 'course') {
    return AjaxBasics.request({
      ...EnumAPI.integral_new_task,
      body: { regEx, ruleCode: '4' },
    });
  }
  async onInitSearchParams() {
    const scene = await AjaxBasics.requestEnum(EnumAPI.integral_scene_v2, {
      labelKey: 'name',
      valueKey: 'code',
    });
    this.searchParams.set({ scene });
  }

  async onInitSearchParamsV2() {
    const sceneV2 = await AjaxBasics.requestEnum(EnumAPI.integral_scene_v2, {
      labelKey: 'name',
      valueKey: 'code',
    });
    this.searchParams.set({ sceneV2 });
  }
  // 积分任务是否完成
  async onAllTaskStatus() {
    try {
      let res: any = await AjaxBasics.request(
        EnumAPI.integral_allTaskStatus_v2,
      );
      this.searchParams.set({
        TaskStatus: lodash.get(res, 'finishStatus', true),
      });
    } catch (error) {
      console.log(error);
    }
  }

  // 签到按钮
  async onSmbsignin() {
    return await AjaxBasics.request({
      ...EnumAPI.integral_smb_signin,
      body: {
        ruleCode: '111',
      },
    });
  }

  // 签到状态
  async onGetSmbsigninStatus() {
    return await AjaxBasics.request({
      ...EnumAPI.integral_smb_getSigninStatus,
      body: { ruleId: 111, orgType: 2 },
    });
  }

  /**
   * 学习积分 产品资料接口
   */
  onProductView(body) {
    return AjaxBasics.request({
      ...EnumAPI.integral_product_view,
      body: {
        ...body,
        ruleCode: '115',
      },
    });
  }

  /** 积分任务 */
  TaskController = new BasesController(IntegralController.options.Task);
  /** 积分参数 */
  searchParams = new SearchParams();
}
class SearchParams extends BaseModel {
  get IntegralType() {
    return [
      { label: '积分收支明细', value: '0' },
      { label: '积分兑换记录', value: '1' },
      // { label: '过期积分明细', value: '2' },
      { label: '积分兑换订单', value: '3' },
    ];
  }
  get IntegralSalesType() {
    return [
      { label: '本周积分榜', value: '1' },
      { label: '历史周积分榜', value: '0' },
    ];
  }
  get IntegralSalesTypeISG() {
    return [
      { label: '季度排行榜', value: '1' },
      { label: '年度排行榜', value: '0' },
    ];
  }
  @computed
  get IntegralScene() {
    if (this.value?.scene) {
      return lodash.concat([{ label: '全部', value: '' }], this.value?.scene);
    }
  }

  @computed
  get IntegralSceneV2() {
    if (this.value?.sceneV2) {
      return lodash.concat([{ label: '全部', value: '' }], this.value?.sceneV2);
    }
  }

  @computed
  get IntegralTaskStatus() {
    if (this.value?.TaskStatus) {
      return this.value?.TaskStatus;
    }
  }
}
